import type { ReactNode } from 'react';

export interface IUI {
	className?: string;
	name?: string;
	disabled?: boolean;
	children?: ReactNode;
	id?: string;
	'data-testid'?: string;
}

export type TVariant =
	| 'primary'
	| 'secondary'
	| 'danger'
	| 'ghost'
	| 'link'
	| 'outline';

export type TSize = 'inherit' | 'xs' | 'sm' | 'md' | 'lg';

export enum EStatus {
	Opened = 'opened',
	Pending = 'pending',
	Approved = 'approved',
	Signed = 'signed',
	Paid = 'paid',
	Declined = 'declined',
	Closed = 'closed',
}

export enum EPaymentMethod {
	CreditCard = 'credit card',
	BankTransfer = 'bank transfer',
}
